import { ReactNode } from 'react';
import SharedToolbar from '../../../../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../../../../shared/analytics/module-list';
import SharedIconButton from '../../../../../../shared/buttons/shared-icon-button';

export interface GpanelContactsGridToolbarProps {
  selection: number[];
  onRefresh: () => void;
  contactsToolbarActions?: (selection: number[]) => ReactNode;
  actions?: React.ReactNode;
  noSharedGridState?: boolean;
}

export default function GpanelContactsGridToolbar({
  selection,
  onRefresh,
  contactsToolbarActions,
  actions,
  noSharedGridState,
}: GpanelContactsGridToolbarProps) {
  return (
    <SharedToolbar
      primaryButtons={actions && actions}
      secondaryButtons={
        <>
          {contactsToolbarActions && contactsToolbarActions(selection)}
          <SharedIconButton
            variant="refresh"
            onClick={onRefresh}
            tooltipLabel="Refresh"
          />
          {noSharedGridState ? null : (
            <SharedGridStateIconButton
              gridStateKey={'gpanelContactsGridStates'}
              module={ModuleList.modules.directory.name}
              section={ModuleList.modules.directory.sections.gpanelContacts}
            />
          )}
        </>
      }
    />
  );
}
